<template>
    <tree
        :data="treeData"
        :options="treeOptions"
        @node:selected="onNodeSelected"
    ></tree>
</template>

<script>
import _ from "lodash";
import { toTreeData } from "../../components/tree/utils.js";

import LiquorTree from "liquor-tree";

export default {
    name: "OTree",
    components: {
        Tree: LiquorTree,
    },
    model: {
        value: "value",
        event: "change",
    },
    props: {
        items: { type: Array, default: () => [] },
        idField: { type: String, default: "id" },
        textField: { type: String, default: "description" },
        parentsArrayField: { type: String, default: "parents" },
        value: { type: [Array, Number], default: null },
        disabled: { type: Boolean, default: false },

        valueType: {
            type: String,
            default: "id",
        } /* array = array to this node, id= Id of the selected node only*/,
    },
    data() {
        return {
            treeOptions: {
                selectable: true,
                checkboxes: true,
            },
        };
    },
    methods: {
        onNodeSelected(node) {
            if (this.valueType === "id") {
                this.$emit("change", node[this.idField]);
            } else {
                var item = this.itemsByID[node[this.idField]];

                if (item) {
                    this.$emit("change", [...item.parents, item.id]);
                } else {
                    this.$emit("change", null);
                }
            }
        },
    },
    computed: {
        itemsByID() {
            return _.keyBy(this.items, "id");
        },
        treeData() {
            var current_value = this.value;

            if (this.valueType !== "id") {
                if (current_value) {
                    current_value = current_value[current_value.length - 1]; // the last ID is what we want!
                } else {
                    current_value = null;
                }
            }

            return toTreeData(
                this.items,
                this.idField,
                this.textField,
                this.parentsArrayField,
                this.value,
                this.disabled,
            );
        },
    },
};
</script>
